// Use existing cartData from form-template.liquid or create new one
if (typeof cartData === 'undefined') {
  var cartData = {};
}

// Get cart token using Cart Ajax API as it's not available anymore from withing the liquid object.
var xhrGetCart = new XMLHttpRequest();
xhrGetCart.open('GET', '/cart.js', true);
xhrGetCart.onreadystatechange = function() {
  if (this.readyState === 4) {
    if (this.status >= 200 && this.status < 400) {
      try {
        var cartJson = JSON.parse(this.responseText);
        if ("token" in cartJson) {
          console.log("Cart token received from Cart Ajax API");
          cartData.token = cartJson.token;
        }
      } catch {}
    }
  }
};
xhrGetCart.send();
xhrGetCart = null;

let initInterval = setInterval(function() {
  if ("jQuery" in window) {
    initPageForm(window.jQuery);
    clearInterval(initInterval);
  }
});

let formValidationRules = {
  "order-form-register-email": "required email",
  "order-form-register-f-name": "required",
  "order-form-register-l-name": "required",
  "order-form-register-street-address": "required",
  "order-form-register-city": "required",
  "order-form-register-phone": "required phone",
  "order-form-reference-phone-number": "phone",
  "dob": "required",
  //"last-pay": "required",
  "next-pay": "required",
  "order-form-employment-status": "required",
  "bsb-number": "required bsb-number",
  "account-number": "required bank-accno",
  "bank-name": "required"
};

function initPageForm($) {
  let $signUpEmailInput = $("#order-form-register-email");
  
  // Vercel API base URL
  var vercelApiBase = "https://src-au.vercel.app/api";
  // API endpoints
  var newApiURL = vercelApiBase + "/create-order";
  var saveCartURL = vercelApiBase + "/save-cart";
  // Legacy API (kept for reference, not used)
  var apiURL = "https://layaway-au.cyberwork.shop/api/";
  
  let devMode = false;
  if (lsTest() === true && localStorage.getItem("dev") === "1") {
    //apiURL = "https://layaway.loc/api/";
  }

  let $submitBtn = $("#btn-submit");
  let $province = $("#province");

  initSignInForm();
  initAbandonedCart();

  $("[name='order[pay_frequency]']").on("click", function() {
    $("[data-payment-confirmation]").hide();
    $("[data-payment-confirmation='" + $(this).val() + "']").css("display", "inline");
  });

  let $signaturePadEl = $("#signature-pad");
  let lastWindowWidth = $(window).width();
  $signaturePadEl.attr("width", $signaturePadEl.width());
  $(window).on("resize", function() {
    /**
     * Window width check required because "resize" event is triggered on some mobile devices on scroll event.
     * When signaturePad canvas `width` attribute is updated, it clears the canvas, but isEmpty() check shows that it
     * has a signature on it. It was leading to the bug when the signature was disappearing when users were scrolling
     * the page and they were able to submit the form with empty canvas.
     */
    let currentWindowWidth = $(window).width();
    if (currentWindowWidth !== lastWindowWidth) {
      if ("signaturePad" in window) {
        window.signaturePad.clear();
      }
      lastWindowWidth = currentWindowWidth;
      $signaturePadEl.attr("width", 600);
      $signaturePadEl.attr("width", $signaturePadEl.width());
    }
  });

  $("#btn-clear-signature").on("click", function() {
    if ("signaturePad" in window) {
      window.signaturePad.clear();
    }
  });

  // Set province (if has default)
  if ($province.is("[data-default]")) {
    $province.val($province.attr("data-default")).trigger("change");
  }

  $.each(formValidationRules, function(fieldId) {
    let $field = $("#" + fieldId);
    if ($field[0].tagName === "INPUT") {
      $field.on("blur", function() {
        validateField($(this));
      });
    } else if ($field[0].tagName === "SELECT") {
      $field.on("change", function() {
        validateField($(this));
      });
    }
  });

  function validateField($field) {
    if ($field.attr("id") in formValidationRules) {
      let $errorSpan = $field.parent().find("span.error");
      let labelFieldForError = "";
      let $label = $field.parents(".form-group").find("label");
      if ($label.is("[data-label]")) {
        labelFieldForError = $label.data("label");
      } else {
        labelFieldForError = $label.text();
        labelFieldForError = labelFieldForError.toLowerCase();
        labelFieldForError = labelFieldForError.charAt(0).toUpperCase() + labelFieldForError.slice(1);
      }
      let valid = true;
      let errMsg = "";

      let val = $.trim($field.val());
      if (formValidationRules[$field.attr("id")].match(/required/)) {
        if (!val.length) {
          valid = false;
          errMsg = labelFieldForError + " is required";
        }
      }

      if (valid && formValidationRules[$field.attr("id")].match(/email/)) {
        if (!validateEmail(val)) {
          valid = false;
          errMsg = "Invalid email";
        }
      }

      if (valid && formValidationRules[$field.attr("id")].match(/bsb-number/)) {
        if (!validateBsbNumber(val)) {
          valid = false;
          errMsg = labelFieldForError + " must contain 6 digits";
        }
      }

      if (valid && formValidationRules[$field.attr("id")].match(/bank-accno/)) {
        if (!validateBankAccno(val)) {
          valid = false;
          errMsg = labelFieldForError + " must contain digits only";
        }
      }

      if (valid && formValidationRules[$field.attr("id")].match(/phone/)) {
        if (formValidationRules[$field.attr("id")].match(/required/) || (!formValidationRules[$field.attr("id")].match(/required/) && val.length)) {
          val = val.replace(/-/g, "").replace(/\s/g, "");
          if (!val.match(/^\+?[0-9]+$/)) {
            valid = false;
            errMsg = labelFieldForError + " must contain digits only";
          }
        }
      }

      if (!valid) {
        $field.addClass("error");
        if ($errorSpan.length) {
          $errorSpan.text(errMsg).show();
        } else {
          $field.parent().append("<span class='error' style='display: block;'>" + errMsg + "</span>");
        }
        return {valid: false, msg: errMsg};
      } else {
        $field.removeClass("error");
        $errorSpan.empty().hide();
        return {valid: true};
      }
    } else {
      return null;
    }
  }

  $submitBtn.on("click", function(e) {
    e.preventDefault();

    if ($(this).is("[disabled]")) {
      return;
    }

    if (!validateForm()) {
      return;
    }

    $(this).attr("disabled", "disabled").text("Processing...");

    // ===== BUILD API PAYLOAD =====
    // Determine site from currency field
    const currency = $("[name='order[currency]']").val() || 'AUD';
    const site = currency === 'NZD' ? 'nz' : 'au';

    // Collect customer data from form fields
    const customer = {
      first_name: $.trim($("#order-form-register-f-name").val()),
      last_name: $.trim($("#order-form-register-l-name").val()),
      email: $.trim($("#order-form-register-email").val()),
      phone: $.trim($("#order-form-register-phone").val()).replace(/-/g, "").replace(/\s/g, ""),
      address: $.trim($("#order-form-register-street-address").val()),
      address2: $.trim($("#order-form-register-street-address-2").val() || ""),
      city: $.trim($("#order-form-register-city").val()),
      state: $.trim($("#province").val() || ""),
      postcode: $.trim($("[name='order[address][zip]']").val() || "")
    };

    // Build items array from cart data
    let items = [];
    if (cartData && cartData.items && cartData.items.length > 0) {
      items = cartData.items.map(item => {
        const tags = item.product ? item.product.tags : [];
        const weeks = getWeeksFromTags(tags);
        // Use metafield total price (no fallback - metafield is authoritative)
        const totalValue = item.metafieldTotalPrice || 0;
        return {
          variant_id: item.id,
          product_id: item.product_id,
          title: item.title,
          image: item.image,
          price: item.price, // weekly price in cents
          weeks: weeks,
          quantity: item.quantity || 1,
          total_value: totalValue // total contract value from metafield in cents
        };
      });
    }

    // Collect additional form details including signature
    const formDetails = {
      date_of_birth: $.trim($("#dob").val() || ""),
      next_pay_date: $.trim($("#next-pay").val() || ""),
      employment_status: $.trim($("#order-form-employment-status").val() || ""),
      pay_frequency: $.trim($("#order-form-pay-frequency").val() || ""),
      bsb_number: $.trim($("[name='order[bsb_number]']").val() || ""),
      account_number: $.trim($("[name='order[account_number]']").val() || ""),
      bank_name: $.trim($("[name='order[bank_name]']").val() || ""),
      reference_first_name: $.trim($("[name='order[reference][first_name]']").val() || ""),
      reference_last_name: $.trim($("[name='order[reference][last_name]']").val() || ""),
      reference_phone: $.trim($("[name='order[reference][phone]']").val() || ""),
      agreed_to_terms: $("#agreed_to_terms").is(":checked"),
      agreed_to_charges: $("#agreed_to_charges").is(":checked"),
      agreed_to_cancellation: $("#agreed_to_cancellation").is(":checked"),
      agreed_to_payment_info: $("#agreed_to_payment_info").is(":checked"),
      confirmed_affordability: $("#confirmed_affordability").is(":checked"),
      subscribe_to_mailing: $("#order-subscribe-to-mailing-list").is(":checked"),
      is_bundle: items.length > 1,
      bundle_item_count: items.length.toString(),
      signature: ("signaturePad" in window && !window.signaturePad.isEmpty()) ? window.signaturePad.toDataURL() : "",
      submitted_at: new Date().toISOString()
    };

    // Build API payload
    const payload = {
      site: site,
      customer: customer,
      items: items,
      formDetails: formDetails
    };

    console.log('Submitting to API:', payload);

    // ===== CALL NEW VERCEL API =====
    fetch(newApiURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => response.json())
    .then(resp => {
      console.log('API response:', resp);
      
      if (resp.success) {
        // Track conversions
        if ("fbq" in window && "fbqPurchaseObj" in window) {
          window.fbq('track', 'Purchase', window.fbqPurchaseObj);
        }
        if ("snaptr" in window) {
          window.snaptr('track', 'PURCHASE');
        }

        // Clear the cart
        $.ajax({
          type: "POST",
          url: "/cart/clear.js",
          dataType: "json"
        }).always(function() {
          // Show thank you overlay instead of redirect
          var customerEmail = $.trim($("#order-form-register-email").val());
          if (typeof window.showThankYouOverlay === 'function') {
            window.showThankYouOverlay(customerEmail);
          } else {
            // Fallback to redirect if overlay function not available
            if (resp.contract_url) {
              location.href = resp.contract_url;
            } else if (resp.order_reference) {
              location.href = "/pages/contract?ref=" + resp.order_reference;
            } else {
              location.href = "/pages/thank-you";
            }
          }
        });
      } else {
        // Handle error
        let errorMsg = resp.message || resp.error || "Error submitting application";
        alert(errorMsg);
        $submitBtn.text("Submit").removeAttr("disabled");
      }
    })
    .catch(error => {
      console.error('API error:', error);
      $submitBtn.text("Submit").removeAttr("disabled");
      alert("Something went wrong... Please try again");
    });
  });

  function validateForm() {
    let valid = true;
    let errors = [];
    $("#order-form-step-1 input:not([name^='customer'])").each(function() {
      if ($(this).attr("name") === "order[address][address2]" || $(this).attr("name") === "order[address][zip]") {
        return true;
      }

      let validation = validateField($(this));
      if (validation) {
        if (validation.valid) {
          return true;
        } else {
          valid = false;
          errors.push(" - " + validation.msg);
          return true;
        }
      }

      let id = $(this).attr("id");
      let labelFieldForError = "";
      let $label = $(this).parents(".form-group").find("label");
      if ($label.is("[data-label]")) {
        labelFieldForError = $label.data("label");
      } else {
        labelFieldForError = $label.text();
        labelFieldForError = labelFieldForError.toLowerCase();
        labelFieldForError = labelFieldForError.charAt(0).toUpperCase() + labelFieldForError.slice(1);
      }
      let val = $.trim($(this).val());
      if (!val.length) {
        valid = false;
        var errMsg = labelFieldForError + " is required";
        errors.push(" - " + errMsg);
        $(this).addClass("error");
      } else if (id === "order-form-register-phone") {
        if (!val.match(/^\+?[0-9]+$/)) {
          valid = false;
          errors.push(" - " + labelFieldForError + " must contain digits only");
          $(this).addClass("error");
        } else {
          $(this).removeClass("error");
        }
      } else if (id === "order-form-register-zip") {
        if (!val.match(/^[0-9]+$/)) {
          valid = false;
          errors.push(" - " + labelFieldForError + " must contain digits only");
          $(this).addClass("error");
        } else {
          $(this).removeClass("error");
        }
      } else {
        $(this).removeClass("error");
      }
      if ($(this).attr("name") && $(this).attr("name").match(/confirm_password/) && !$(this).hasClass("error")) {
        // Check passwords are equal
        if ($("#order-form-register-password").val() !== $("#order-form-register-confirm-password").val()) {
          valid = false;
          errors.push("Passwords are not equal");
          $("#order-form-register-password, #order-form-register-confirm-password").addClass("error");
        } else {
          $("#order-form-register-password, #order-form-register-confirm-password").removeClass("error");
        }
      }
    });
    $("#order-form-step-2").find("input,select").each(function() {
      let validation = validateField($(this));
      if (validation) {
        if (validation.valid) {
          return true;
        } else {
          valid = false;
          errors.push(" - " + validation.msg);
          return true;
        }
      }

      let id = $(this).attr("id");
      let labelFieldForError = "";
      let $label = $(this).parents(".form-group").find("label");
      if ($label.is("[data-label]")) {
        labelFieldForError = $label.data("label");
      } else {
        labelFieldForError = $label.text();
        labelFieldForError = labelFieldForError.toLowerCase();
        labelFieldForError = labelFieldForError.charAt(0).toUpperCase() + labelFieldForError.slice(1);
      }
      let val = $.trim($(this).val());
      if (!val.length) {
        valid = false;
        if (labelFieldForError.length) {
          errors.push(" - " + labelFieldForError + " is required");
        }
        $(this).addClass("error");
      } else if (id === "account-number") {
        if (!val.match(/^[0-9-\s]+$/)) {
          valid = false;
          errors.push(" - " + labelFieldForError + " must contain digits only");
          $(this).addClass("error");
        } else {
          $(this).removeClass("error");
        }
      } else {
        $(this).removeClass("error");
      }
    });
    let $stepContainer = $("#order-form-step-3");
    $stepContainer.find("input[type=text]").each(function() {
      if ($(this).is("#order-form-reference-f-name") || $(this).is("#order-form-reference-l-name")) {
        return true;
      }

      let validation = validateField($(this));
      if (validation) {
        if (validation.valid) {
          return true;
        } else {
          valid = false;
          errors.push(" - " + validation.msg);
          return true;
        }
      }

      let id = $(this).attr("id");
      let $label = $(this).parents(".form-group").find("label");
      let labelFieldForError = "";
      if ($label.is("[data-label]")) {
        labelFieldForError = $label.data("label");
      } else {
        labelFieldForError = $label.text();
        labelFieldForError = labelFieldForError.toLowerCase();
        labelFieldForError = labelFieldForError.charAt(0).toUpperCase() + labelFieldForError.slice(1);
      }
      let val = $.trim($(this).val());

      if (id !== "order-form-reference-phone-number" && !val.length) {
        valid = false;
        if (labelFieldForError.length) {
          errors.push(" - " + labelFieldForError + " is required");
        }
        $(this).addClass("error");
      } else if (id === "order-form-reference-phone-number" && val.length) {
        val = val.replace(/-/g, "").replace(/\s/g, "");
        if (!val.match(/^\+?[0-9]+$/)) {
          valid = false;
          errors.push(" - " + labelFieldForError + " must contain digits only");
          $(this).addClass("error");
        } else {
          $(this).removeClass("error");
        }
      } else {
        $(this).removeClass("error");
      }
    });
    $stepContainer.find("input[type=checkbox]:not(#order-subscribe-to-mailing-list)").each(function() {
      if (!$(this).is(":checked")) {
        errors.push(" - You must read and agree to the terms and conditions");
        valid = false;
      }
    });
    if ("signaturePad" in window) {
      if (window.signaturePad.isEmpty()) {
        errors.push(" - Electronic signature is required");
        valid = false;
      }
    }
    if (!valid) {
      errors = errors.filter(onlyUnique);
      alert(errors.join("\n"));
    }
    return valid;
  }

  function initSignInForm() {
    $(document).on("click", ".folded", function() {
      var ref = $(this).data("ref");
      $(this).removeClass("folded").addClass("unfolded");
      $("#" + ref).stop(true, true).slideDown();
    }).on("click", ".unfolded", function() {
      var ref = $(this).data("ref");
      $(this).removeClass("unfolded").addClass("folded");
      $("#" + ref).stop(true, true).slideUp();
    });
  }

  function initAbandonedCart() {
    let fieldsToCheck = ["order-form-register-email", "order-form-register-f-name", "order-form-register-l-name", "order-form-register-phone"];
    $.each(fieldsToCheck, function(key, fieldId) {
      let $field = $("#" + fieldId);
      $field.on("blur", function() {
        sendAbandonedCart();
      });
    });
    sendAbandonedCart();

    function sendAbandonedCart() {
      let allFieldsFilled = true;
      $.each(fieldsToCheck, function(key, fieldId) {
        if (fieldId === "order-form-register-phone") { // Phone number is not necessary to save the cart
          return true;
        }
        let $field = $("#" + fieldId);
        let val = $.trim($field.val());
        if (!val.length) {
          allFieldsFilled = false;
          return false;
        }
      });
      if (!allFieldsFilled) {
        return false;
      }
      
      // Determine site from currency
      const currency = $("[name='order[currency]']").val() || 'AUD';
      const site = currency === 'NZD' ? 'nz' : 'au';
      
      // Build cart items array
      let cartItems = [];
      if ("item_count" in cartData && cartData.item_count > 0) {
        for (let i = 0; i < cartData.item_count; i++) {
          cartItems.push({
            id: cartData.items[i].id,
            title: cartData.items[i].title,
            handle: cartData.items[i].handle
          });
        }
      }
      
      // Build payload for new Vercel API
      let payload = {
        site: site,
        token: cartData.token,
        first_name: $.trim($("#order-form-register-f-name").val()),
        last_name: $.trim($("#order-form-register-l-name").val()),
        phone: $.trim($("#order-form-register-phone").val()),
        email: $.trim($signUpEmailInput.val()),
        items: cartItems
      };
      
      // Send to new Vercel save-cart endpoint
      fetch(saveCartURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .then(response => response.json())
      .then(resp => {
        if (!resp.success) {
          console.warn("Failed to save abandoned cart:", resp.message || resp.error);
        } else {
          console.log("Abandoned cart saved successfully");
        }
      })
      .catch(err => {
        console.warn("Connection or server error on saving cart:", err);
      });
    }
  }
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, {type: contentType});
};

function lsTest(){
  let test = 'test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch(e) {
    return false;
  }
}

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function validateBsbNumber(bsbNumber) {
  var re = /^[0-9]{6}$/;
  return re.test(String(bsbNumber));
}

function validateBankAccno(bankAccno) {
  var re = /^[0-9-\s]+$/;
  return re.test(String(bankAccno));
}

/**
 * ==========================================
 * BUNDLE CALCULATIONS
 * ==========================================
 * Functions for calculating bundle delivery schedules,
 * sorting items by price, and preparing bundle data for API.
 */

/**
 * Extract weeks value from product tags
 * @param {Array} tags - Array of product tags
 * @returns {number} - Number of weeks
 */
function getWeeksFromTags(tags) {
  if (!tags || !Array.isArray(tags)) return 1;
  for (let tag of tags) {
    if (tag.includes("weeks:")) {
      return parseInt(tag.split(":")[1].trim(), 10) || 1;
    }
  }
  return 1;
}

/**
 * Extract delivery-after value from product tags
 * @param {Array} tags - Array of product tags
 * @returns {number} - Number of payments before delivery
 */
function getDeliveryAfterFromTags(tags) {
  if (!tags || !Array.isArray(tags)) return 0;
  for (let tag of tags) {
    if (tag.includes("delivery-after:")) {
      return parseInt(tag.split(":")[1].trim(), 10) || 0;
    }
  }
  return 0;
}

/**
 * Extract delivery-charge value from product tags
 * @param {Array} tags - Array of product tags
 * @returns {number} - Delivery charge in cents
 */
function getDeliveryChargeFromTags(tags) {
  if (!tags || !Array.isArray(tags)) return 0;
  for (let tag of tags) {
    if (tag.includes("delivery-charge:")) {
      return parseInt(tag.split(":")[1].trim(), 10) || 0;
    }
  }
  return 0;
}

/**
 * Extract maximum-hire-fee value from product tags
 * @param {Array} tags - Array of product tags
 * @returns {number} - Maximum hire fee
 */
function getMaxHireFeeFromTags(tags) {
  if (!tags || !Array.isArray(tags)) return 0;
  for (let tag of tags) {
    if (tag.includes("maximum-hire-fee:")) {
      return parseInt(tag.split(":")[1].trim(), 10) || 0;
    }
  }
  return 0;
}

/**
 * Calculate bundle schedule from cart data
 * Sorts items by total price (lowest first) and calculates delivery order
 * @param {Object} cartData - Cart data from Shopify
 * @returns {Object} - Bundle schedule with items, totals, and delivery info
 */
function calculateBundleSchedule(cartData) {
  if (!cartData || !cartData.items || cartData.items.length === 0) {
    return null;
  }

  const isBundle = cartData.items.length > 1;
  
  // Map items with calculated values
  let items = cartData.items.map(item => {
    const tags = item.product ? item.product.tags : [];
    const weeks = getWeeksFromTags(tags);
    const deliveryAfter = getDeliveryAfterFromTags(tags);
    const deliveryCharge = getDeliveryChargeFromTags(tags);
    const maxHireFee = getMaxHireFeeFromTags(tags);
    const weeklyPrice = item.price; // in cents
    // Use metafield total price (no fallback - metafield is authoritative)
    const totalPrice = item.metafieldTotalPrice || 0;
    
    return {
      variantId: item.id,
      productId: item.product_id,
      title: item.title,
      handle: item.handle,
      weeklyPrice: weeklyPrice,
      weeks: weeks,
      totalPrice: totalPrice,
      deliveryAfter: deliveryAfter,
      deliveryCharge: deliveryCharge,
      maxHireFee: maxHireFee,
      image: item.image
    };
  });

  // Sort by total price (lowest first - delivered first)
  items.sort((a, b) => a.totalPrice - b.totalPrice);

  // Calculate delivery schedule
  let cumulativeWeeks = 0;
  items.forEach((item, index) => {
    item.deliveryOrder = index + 1;
    cumulativeWeeks += item.weeks;
    
    if (isBundle) {
      // For bundles: deliver after item's portion is paid off
      item.estimatedDeliveryWeek = cumulativeWeeks;
    } else {
      // For single items: use the delivery-after tag
      item.estimatedDeliveryWeek = item.deliveryAfter;
    }
  });

  // Calculate bundle totals
  const combinedWeeklyPayment = items.reduce((sum, item) => sum + item.weeklyPrice, 0);
  const totalContractValue = items.reduce((sum, item) => sum + item.totalPrice, 0);
  const contractDuration = Math.max(...items.map(item => item.weeks));

  return {
    isBundle: isBundle,
    itemCount: items.length,
    items: items,
    combinedWeeklyPayment: combinedWeeklyPayment,
    totalContractValue: totalContractValue,
    contractDuration: contractDuration
  };
}

/**
 * Get weekly payment cap based on currency
 * @param {string} currency - Currency code (AUD, NZD, etc.)
 * @returns {Object} - Cap in cents and display string
 */
function getWeeklyPaymentCap(currency) {
  if (currency === 'NZD') {
    return { cents: 1500, display: '$15' };
  }
  // Default to AUD
  return { cents: 3500, display: '$35' };
}

/**
 * Check if bundle exceeds weekly payment cap
 * @param {Object} bundleSchedule - Bundle schedule from calculateBundleSchedule
 * @param {string} currency - Currency code
 * @returns {Object} - Validation result (kept for backward compatibility)
 */
function validateBundleWeeklyCap(bundleSchedule, currency) {
  const cap = getWeeklyPaymentCap(currency);
  const exceedsCap = bundleSchedule.combinedWeeklyPayment > cap.cents;
  
  return {
    isValid: true,  // Always valid - cap extends duration, doesn't block
    exceedsCap: exceedsCap,
    capCents: cap.cents,
    capDisplay: cap.display,
    combinedPayment: bundleSchedule.combinedWeeklyPayment,
    overageAmount: exceedsCap ? bundleSchedule.combinedWeeklyPayment - cap.cents : 0
  };
}

/**
 * Calculate capped duration for bundle
 * When combined weekly exceeds cap, this calculates the extended contract duration
 * 
 * @param {Object} bundleSchedule - Bundle schedule from calculateBundleSchedule
 * @param {string} currency - Currency code (AUD/NZD)
 * @returns {Object} - Capped duration info
 */
function calculateCappedDuration(bundleSchedule, currency) {
  const cap = getWeeklyPaymentCap(currency);
  const combinedWeekly = bundleSchedule.combinedWeeklyPayment;
  const totalValue = bundleSchedule.totalContractValue;
  
  const capApplies = combinedWeekly > cap.cents;
  const actualWeeklyPayment = capApplies ? cap.cents : combinedWeekly;
  
  // Calculate duration based on actual payment rate
  let contractWeeks = bundleSchedule.contractDuration;
  if (capApplies) {
    contractWeeks = Math.ceil(totalValue / cap.cents);
  }
  
  // Recalculate delivery weeks based on capped payment rate
  let cumulativeValue = 0;
  const adjustedItems = bundleSchedule.items.map(item => {
    cumulativeValue += item.totalPrice;
    const deliveryWeek = Math.ceil(cumulativeValue / actualWeeklyPayment);
    return {
      ...item,
      estimatedDeliveryWeek: deliveryWeek
    };
  });
  
  return {
    capApplies: capApplies,
    capCents: cap.cents,
    capDisplay: cap.display,
    combinedWeekly: combinedWeekly,
    actualWeeklyPayment: actualWeeklyPayment,
    totalValue: totalValue,
    originalDuration: bundleSchedule.contractDuration,
    adjustedDuration: contractWeeks,
    items: adjustedItems
  };
}

/**
 * Format cents to currency display string
 * @param {number} cents - Amount in cents
 * @returns {string} - Formatted currency string
 */
function formatCentsToCurrency(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
}

/**
 * Prepare bundle data for API submission
 * @param {Object} bundleSchedule - Bundle schedule from calculateBundleSchedule
 * @param {string} currency - Currency code for cap calculation
 * @returns {Object} - Formatted data for API
 */
function prepareBundleForApi(bundleSchedule, currency) {
  if (!bundleSchedule) return null;

  // Get capped duration info
  const capInfo = calculateCappedDuration(bundleSchedule, currency || 'AUD');

  return {
    type: bundleSchedule.isBundle ? 'bundle' : 'single',
    item_count: bundleSchedule.itemCount,
    combined_weekly_payment: bundleSchedule.combinedWeeklyPayment,
    actual_weekly_payment: capInfo.actualWeeklyPayment,
    cap_applies: capInfo.capApplies,
    total_contract_value: bundleSchedule.totalContractValue,
    contract_duration_weeks: capInfo.adjustedDuration,
    items: capInfo.items.map(item => ({
      variant_id: item.variantId,
      product_id: item.productId,
      title: item.title,
      weekly_price: item.weeklyPrice,
      weeks: item.weeks,
      total_price: item.totalPrice,
      delivery_order: item.deliveryOrder,
      estimated_delivery_week: item.estimatedDeliveryWeek,
      delivery_charge: item.deliveryCharge,
      max_hire_fee: item.maxHireFee
    }))
  };
}

// Make bundle functions available globally
window.BundleUtils = {
  calculateBundleSchedule: calculateBundleSchedule,
  validateBundleWeeklyCap: validateBundleWeeklyCap,
  calculateCappedDuration: calculateCappedDuration,
  getWeeklyPaymentCap: getWeeklyPaymentCap,
  formatCentsToCurrency: formatCentsToCurrency,
  prepareBundleForApi: prepareBundleForApi,
  getWeeksFromTags: getWeeksFromTags,
  getDeliveryAfterFromTags: getDeliveryAfterFromTags
};